import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ThankYou from './pages/ThankYou';
import Modal from "../src/components/Modal"
import ViscatTest from './pages/VisCAT_test';
import Home from './pages/Home';
import TestCompleted from './pages/TestCompleted';
import URLInput from './pages/URLInput';
// https://stackoverflow.com/questions/77753500/in-reactjs-how-to-request-exit-fullscreen-while-also-handling-the-fullscreen-ev

const App = () => {

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div>
        <Modal />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/url-input" element={<URLInput />} />
          <Route path="/VisCAT_test" element={<ViscatTest />} />
          <Route path="/ThankYou" element={<ThankYou />} />
          <Route path="/TestCompleted" element={<TestCompleted />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;